<script>
    import Dropdown from './Dropdown.svelte'

    export let disabled
    export let duration
    export let unit
    export let unitSelected = option => console.log('Option Selected', option)

    const allowed = [8, 9, 35, 36, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57] // TAB, <-, ->, HOME, END, DEL and BACKSPACE, numbers,

    const periods = [
        { id: 1 , value: 'D', text: 'dia(s)' },
        { id: 2 , value: 'M', text: 'mês(s)' },
        { id: 3 , value: 'Y', text: 'ano(s)' }
    ]

    $: unitOpt = unitOptionFor(unit)

    function unitOptionFor(unit) {
        return periods.find(it => it.value === unit)
    }

    function isDurationAllowed(e) {
        if(!allowed.find(i => i === e.keyCode)) {
            e.preventDefault()
        }
    }

</script>

<div class="four wide field" class:disabled>
    <label for="period">Período</label>
    <input  name="period"
            maxlength="4"
            on:keydown={isDurationAllowed} 
            bind:value={duration}
            autocomplete="false">
</div>
<div class="field" class:disabled>
    <label for="">&nbsp;</label>
    <Dropdown options={periods} noOption={false} text="selecione" selected={unitOpt} onChange={unitSelected}/>
</div>